import React from 'react';
import { Link } from 'react-router-dom';
import SubPage from '../components/site/SubPage';
import { PageSection, PageTitleBox } from '../components/site/SubPageParts';

const PURPLE = '#8E3A9B';

const PROFILE = [
  {
    title: 'World Changer',
    body: 'Improve the world through purpose, action, and influence.',
  },
  {
    title: 'Curious',
    body: 'Inquisitive and eager to explore new ideas to solve intractable problems.',
  },
  {
    title: 'Contrarian',
    body: 'Relentless problem-solvers, unafraid to challenge assumptions by being creative and forward-thinking.',
  },
  {
    title: 'Purpose Driven',
    body: 'Actions, decisions, and goals guided by determination to deliver positive change.',
  },
];

const PRINCIPLES = [
  { title: '1st Principles', body: 'Understand the interconnected dynamics of the problem.' },
  { title: '2nd Principles', body: 'Solving intractable problems.' },
  { title: '3rd Principles', body: 'Ensure the solutions we build actually work.' },
];

const Careers = () => (
  <SubPage title="Career Opportunities">
    <PageTitleBox>
      <span style={{ color: PURPLE }}>Making a difference</span>
    </PageTitleBox>

    <PageSection className="pt-3">
      <div className="px-6 py-8 md:px-10 md:py-12" style={{ backgroundColor: PURPLE }}>
        <p className="text-[24px] font-bold leading-tight text-white md:text-[38px]">
          If you think stealing, abusing and cheating people is wrong &mdash; and want to stop it
          &mdash; this might be your place.
        </p>
      </div>
    </PageSection>

    {/* ---------------- Profile ---------------- */}
    <PageSection className="pt-8">
      <div className="flex flex-wrap items-baseline gap-x-6 gap-y-2">
        <h2 className="text-[22px] font-bold text-black md:text-[28px]">Our Profile.</h2>
        <p className="text-[15px] text-black md:text-[18px]">
          Inquisitive and eager to explore new ideas to solve intractable problems.
        </p>
      </div>

      <div className="mt-6 grid grid-cols-1 gap-6 md:grid-cols-2 md:gap-8">
        {PROFILE.map((trait) => (
          <div key={trait.title} className="border border-black bg-[#F2F2F2] px-5 py-4 md:px-6 md:py-5">
            <h3 className="text-[17px] font-bold text-black md:text-[19px]">{trait.title}</h3>
            <p className="mt-2 text-[15px] leading-snug text-black md:text-[17px]">{trait.body}</p>
          </div>
        ))}
      </div>
    </PageSection>

    {/* ---------------- How we think ---------------- */}
    <PageSection className="pt-12">
      <div className="grid grid-cols-1 gap-8 md:grid-cols-2 md:gap-14">
        {/* The mark carries the whole left half rather than sitting small under
            the heading, which left most of this column empty. */}
        <div className="flex flex-col">
          <h2 className="text-[24px] font-bold text-black md:text-[30px]">/ NuVola AI.</h2>
          <div className="mt-5 flex flex-1 items-center justify-center md:mt-6">
            <img
              src="/images/site/nav/ai-cloud-black.png"
              alt="NuVola AI"
              className="h-auto w-full max-w-[280px] object-contain md:max-w-[460px]"
            />
          </div>
        </div>

        <div>
          <p className="text-[15px] leading-relaxed text-black md:text-[18px]">
            It&rsquo;s built around three unique integrated principles. While each role is distinct,
            they are intentionally designed to overlap, enabling teams to pursue outcomes from
            complementary &mdash; and often unorthodox &mdash; perspectives.
          </p>

          <h3 className="mt-7 text-[20px] font-bold text-black md:text-[24px]">How we think.</h3>
          <dl className="mt-3 space-y-4 border border-black/20 px-5 py-5 md:px-7 md:py-6">
            {PRINCIPLES.map((principle) => (
              <div key={principle.title}>
                <dt className="text-[16px] font-bold text-black md:text-[18px]">
                  {principle.title}
                </dt>
                <dd className="mt-0.5 text-[15px] leading-snug text-black/70 md:text-[17px]">
                  {principle.body}
                </dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </PageSection>

    {/* ---------------- Apply ---------------- */}
    <PageSection className="pt-10">
      <div className="h-px w-full bg-black/25" />
      <div className="mt-6 flex justify-end">
        <Link
          to="/careers/open-roles"
          className="flex items-center gap-4 text-[20px] font-bold text-black hover:text-[#0A6EA8] md:text-[26px]"
        >
          <span>Open roles</span>
          <span aria-hidden="true">&rarr;</span>
          <span>Apply now</span>
        </Link>
      </div>
    </PageSection>
  </SubPage>
);

export default Careers;
